import { Box, Button, Menu, MenuItem, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import avatar from "../../../../asset/imgs/avatars/2.png";

import React, { useState } from 'react'

function UserProfileMobile({userImageUr ,handleClick ,userLogin ,logOutHandler }) {
  const theme=useTheme()
    const [anchorEl, setAnchorEl] = useState(null);
      const open = Boolean(anchorEl);
    
      const handleClose = () => {
        setAnchorEl(null);
      };
  return (
     <Box sx={{ display: { md: "none", xs: "flex" } }}>
                <div
                  className="user-info-box"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    className="user-avatar"
                    style={{
                      position: "relative",
                      marginRight: "12px",
                      marginLeft: "12px",
                    }}
                  >
                    <img
                      src={userImageUr ? userImageUr : avatar}
                      alt="avatar"
                      className="avatar-menu-bar"
                      onClick={handleClick}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                        width: "2.2rem",
                        height: "2.2rem",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    className="user-profil-btn"
                    sx={{
                      color: theme.palette.mode === "dark" ? "#FAFAFA" : "#000",
                    }}
                  >
                    {userLogin.firstName + " " + userLogin.lastName}
                    <KeyboardArrowDownIcon sx={{ marginLeft: "0.5rem" }} />
                  </Button>

                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => setSettingModal(true)}>
                      {" "}
                      حساب من{" "}
                    </MenuItem>
                    <MenuItem onClick={logOutHandler}>
                      {" "}
                      خروج از حساب کاربری{" "}
                    </MenuItem>
                  </Menu>
                </div>
              </Box>
  )
}

export default UserProfileMobile